function sendLog(message, source, lineno, colno, error){
    try {
        const websocketsEnabled = window.global_vars.env.WEBSOCKETS_ENABLED;

        if(!websocketsEnabled) {
            return;
        }

        let errorJSON = {};
        // console.log('m: ', message, 's: ', source, 'l: ', lineno, 'c: ', colno, 'e: ',error);
    
        if(error){
            errorJSON = JSON.stringify(error, Object.getOwnPropertyNames(error));
        }else if(message){
            
            errorJSON.stack = {
                error: JSON.stringify(message, Object.getOwnPropertyNames(message)),
                target: JSON.stringify(message.target.baseURI),
                colno: JSON.stringify(colno),
            }
            errorJSON = JSON.stringify(errorJSON);
        }
        
        $.ajax({
            type: 'POST',
            url: '/log',
            data: {'error': errorJSON, 'url': window.location.href, 'user':window.User.id},
        })  
    } catch (error) {
        console.log(error);
    }
    
}

window.onerror = function(message, source, lineno, colno, error){
    // TODO disabled for now
    // sendLog(message, source, lineno, colno, error);
}


// WEBPACK FOOTER //
// ./resources/assets/js/logging.js